import React from "react";
import { Link } from "react-router-dom";

const Home: React.FC = () => {
  return (
    <div className="home fade-in">
      <section className="hero" data-aos="fade-up" data-aos-duration="1000">
        <div className="hero-content">
          <div className="profile-image">
            <img src="/assets/img/profile-picture-3.jpg" alt="Sibi Karthik" />
          </div>
          <h1>I'm Sibi Karthik C V, </h1>
          <h2>
            MSc Data Science & AI @TU/e | Software Engineer @TechUnited
            Eindhoven | P4 Head Football Coach @E.S.V.V. Pusphaira
          </h2>
          <div className="cta-buttons">
            <Link to="/projects" className="btn btn-outline-secondary">
              View My Projects
            </Link>
            <Link to="/experience" className="btn btn-outline-secondary">
              View My Experience
            </Link>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="features-grid">
          <div className="card" data-aos="fade-up" data-aos-delay="100">
            <div className="card-image">
              <img
                src="/assets/img/portfolio/machine-learning.jpeg"
                alt="Machine Learning Project"
              />
            </div>
            <h3>Data Science & Statistics</h3>
            <p>
              Applying advanced AI/ML algorithms to extract meaningful insights
              from complex datasets. Leveraging statistical analysis to validate
              models and drive data-informed decision-making. Experienced in
              feature engineering, statistical modelling, and building scalable
              solutions that solve real-world problems across diverse domains.
            </p>
            <Link to="/projects" className="btn btn-outline">
              Learn More
            </Link>
          </div>
          <div className="card" data-aos="fade-up" data-aos-delay="200">
            <div className="card-image">
              <img
                src="/assets/img/portfolio/ai-ml.jpeg"
                alt="Sports Analytics Project"
              />
            </div>
            <h3>Artificial Intelligence & Machine Learning</h3>
            <p>
              Developing intelligent systems capable of learning from visual
              data, recognizing patterns, and making autonomous inferences.
              Specializing in deep neural networks to solve real-world problems
              across computer vision, tactical analysis, and automated
              detection.
            </p>
            <Link to="/projects" className="btn btn-outline">
              Learn More
            </Link>
          </div>
          <div className="card" data-aos="fade-up" data-aos-delay="300">
            <div className="card-image">
              <img
                src="/assets/img/portfolio/coaching2.jpeg"
                alt="Football Coaching"
              />
            </div>
            <h3>Football Coaching & Sports Analytics</h3>
            <p>
              FA Level 2 (UEFA 'C') licensed football coach integrating tactical
              planning with data-driven insights to enhance team performance.
              Passionate about combining coaching expertise with sports
              analytics to optimize player development and strategic
              decision-making on and off the field.
            </p>
            <a
              href="https://www.samford.edu/sports-analytics/fans/2024/How-reliable-is-Pythagorean-Expectation-to-predict-the-result-of-the-202324-EFL-Soccer-Championship"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline"
            >
              Learn More
            </a>
          </div>
        </div>
      </section>

      {/*
      <section className="about-preview">
        <div className="about-content">
          <h2 className="section-title">About Me</h2>
          <p>
          I'm deeply intrigued by the prospects of artificial intelligence and machine learning,
          especially when it comes to building systems that can learn, adapt, and make smart decisions from data. 
          I work a lot with computer vision, teaching machines to read and understand visual information, whether it’s for health diagnostics, tactical sports analysis, or real-world detection tasks.
          I also explore how data impacts performance in sport: using analytics to reveal patterns, assess strategy, and guide smarter decisions on and off the field. On the side, I’m an FA Level 2 (UEFA 'C') certified football coach.
          It’s a hands-on passion that keeps me connected to the game while complementing my work in data.
          </p>
          <Link to="/about" className="btn btn-primary">
            Read More
          </Link>
        </div>
      </section>
      */}
    </div>
  );
};

export default Home;
